import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'staging',
  production: false,
  getAppDownloadUrl: (
    installerName: string,
  ) => `https://download.stage.rosalyn.ai/staging/desktop-binaries/${installerName}`,
};
